import { isDisplayBlock } from "~/utils/displayBlock";

export const useDisplayBlock = (
	startDate?: string | null,
	endDate?: string | null
) => {
	const shouldDisplay = ref(true);

	const checkDisplay = () => {
		shouldDisplay.value = isDisplayBlock(startDate, endDate);
	};

	checkDisplay();

	return {
		shouldDisplay
	};
};
